import TCWrapper from 'vue-tag-commander';
export function getTagCommander(selfCareSettings) {
    const tagCommanderURL = selfCareSettings === null || selfCareSettings === void 0 ? void 0 : selfCareSettings.declaration.tagCommanderURL;
    return typeof tagCommanderURL === 'string' && process.client === true
        ? TCWrapper.getInstance()
        : null;
}
export function tagCommanderSetVariable(key, value, selfCareSettings, wrapper = getTagCommander(selfCareSettings)) {
    if (wrapper)
        wrapper.setTcVar(key, value);
}
export function tagCommanderSetVariables(vars, selfCareSettings, wrapper = getTagCommander(selfCareSettings)) {
    if (wrapper)
        wrapper.setTcVars(vars);
}
export function tagCommanderReload(selfCareSettings, wrapper = getTagCommander(selfCareSettings)) {
    if (wrapper)
        wrapper.reloadAllContainers();
}
